// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"b2c68516","57":"5aeef134","126":"a73b4fc7","143":"3b2024b7","507":"ff939328","787":"cda612ba","963":"5a6bab74"}[chunkId] + ".chunk.js";
};